export const fragmentUpdateUserLang = /* GraphQL */ `
 fragment fragmentUpdateUserLang on User {
     id
     interface_lang
 }`;
export const fragmentUpdateUserProfile = /* GraphQL */ `
 fragment fragmentUpdateUserProfile on User {
      id
      email
      name
      is_blocked
      profile
      role
      timezone
      phone
 }`;
export const fragmentUpdateUserLearningCenter = /* GraphQL */ `
 fragment fragmentUpdateUserLearningCenter on User {
      id
      # learning_center
 }`;
